<template>
  <v-dialog v-model="isShow" @click:outside="close" width="600">
    <v-card>
      <v-card-title style="text-align: left; font-weight: bold">
        Xác nhận thông tin lớp học
      </v-card-title>
      <v-card-text >
        <div class="d-flex flex-column align-center mb-4" style="color: red">
          <span>Vui lòng kiểm tra thông tin và xác nhận.</span>
          <span>Bạn không được sửa lại sau khi đã xác nhận!</span>
        </div>
        <v-row style="padding: 0 32px">
          <v-col cols="5" class="pb-0 pr-0">Lịch học:</v-col>
          <v-col cols="7" class="pb-0 pl-0">
            <span style="font-weight: bold">
              {{arrangeClassInfo.lessonStartTime}} - {{arrangeClassInfo.lessonEndTime}}
            </span>
            <span>{{formatDateCus(arrangeClassInfo.day, 'DD/MM/YYYY')}}</span>
          </v-col>
          <v-col cols="5" class="pb-0 pr-0">Giáo viên:</v-col>
          <v-col cols="7" style="font-weight: bold" class="pb-0 pl-0">{{arrangeClassInfo.teacherName}}</v-col>
          <v-col cols="5" class="pb-0 pr-0">Trình độ:</v-col>
          <v-col cols="7" style="font-weight: bold" class="pb-0 pl-0">{{arrangeClassInfo.level}}</v-col>
          <v-col cols="5" class="pr-0 pb-0">Bài học:</v-col>
          <v-col cols="7" style="font-weight: bold" class="pl-0 pb-0">{{arrangeClassInfo.lessonTitle}}</v-col>
          <v-col cols="5" class="pr-0">Lớp:</v-col>
          <v-col cols="7" style="font-weight: bold" class="pl-0">{{dataConfirm.classCode}}</v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="d-flex justify-center mb-4">
        <v-btn color="#ED185A" style="color: white" @click="submit">Xác nhận</v-btn>
        <v-btn color="#AEAEB2" style="color: white" @click="close">Đóng</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import TutorSortClassRepository from '@/services/TutorSortClassRepository';
import { mapState } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
import { UPDATE_CARE_TAG } from '@/modules/student_care/constant/constant';

export default {
  name: 'ConfirmCreateClassPopup',
  props: {
    studentCareInfo: {
      type: Object,
      required: true,
    },
    dataConfirm: {
      type: Object,
      required: true,
    },
    arrangeClassInfo: {
      type: Object,
      required: true,
    },
    isShow: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState('student_care', ['listProgram']),
  },
  methods: {
    async submit() {
      const loading = this.$loading.show();
      const item = this.arrangeClassInfo;
      this.joinDate = moment(`${item.day} ${item.lessonStartTime}`, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm:ss');
      const studentProductPending = [{
        studentProductId: this.dataConfirm?.studentProductId,
        joinDate: moment(`${item.day} ${item.lessonStartTime}`, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm:ss'),
        endTime: moment(`${item.day} ${item.lessonEndTime}`, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm:ss'),
        currentProgramId: this.dataConfirm?.currentProgramId,
      }];
      const isSameDay = moment(item.day).isSame(moment().format('YYYY-MM-DD'));
      if (isSameDay) {
        if (moment().add(45, 'minute') > moment(this.joinDate)) {
          this.$swal({
            icon: 'warning',
            title: 'Thông báo !',
            text: 'Buổi học đã diễn ra. Vui lòng chọn buổi học khác',
          });
          this.getLesson();
          Bus.$emit('reload-suggest-lesson');
          return;
        }
      }
      const response = await TutorSortClassRepository.addStudentInClassEmpty(this.dataConfirm.id, { studentProductPending });
      loading.hide();
      if (!response.success) {
        this.$swal({
          icon: 'warning',
          title: 'Thông báo !',
          text: this.getErrorMessage(response) || 'Vui lòng thử lại!',
        });
      } else {
        const payloadUpdate = {
          care_id: this.studentCareInfo.id,
          lms_core_user_id: this.studentCareInfo.lms_core_user_id,
          curriculum_id: this.studentCareInfo.curriculum_id,
          move_to: UPDATE_CARE_TAG.DA_XEP_LOP,
        };
        TutorSortClassRepository.updateCareTag(payloadUpdate);
        this.$swal({
          icon: 'success',
          title: 'Xếp lớp thành công !',
          showCancelButton: false,
          timer: 4000,
        });
        this.doneCreateClass();
        this.close();
      }
    },
    getErrorMessage(error) {
      let { message } = error;
      if (error.errors && error.errors.errors && _.isArray(error.errors.errors)) {
        message = error.errors.errors.join(', ');
      } else if (error.errors && error.errors.message) {
        message = error.errors.message;
      }
      return message;
    },
    doneCreateClass() {
      this.$emit('finish-create-class');
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
